import api from './api';
import type { PlaidLinkOnSuccessMetadata } from 'react-plaid-link';

export interface PlaidLinkTokenResponse {
  linkToken: string;
  expiration: string;
}

export interface PlaidExchangeResponse {
  dataSourceId: string;
  accounts: Array<{
    id: string;
    name: string;
    type: string;
    subtype: string;
  }>;
}

export const plaidApi = {
  async createLinkToken(): Promise<PlaidLinkTokenResponse> {
    const response = await api.post('/api/integrations/plaid/link-token');
    return response.data;
  },

  async exchangePublicToken(
    publicToken: string,
    metadata: PlaidLinkOnSuccessMetadata,
    organizationId?: string | null,
  ): Promise<PlaidExchangeResponse> {
    const response = await api.post('/api/integrations/plaid/exchange-token', {
      publicToken,
      metadata,
      ...(organizationId ? { organizationId } : {}),
    });
    return response.data;
  },

  /** Link token for update mode — repairs a broken Item, keeping its history. */
  async createUpdateLinkToken(dataSourceId: string): Promise<PlaidLinkTokenResponse> {
    const response = await api.post(
      `/api/integrations/plaid/data-sources/${dataSourceId}/update-link-token`,
    );
    return response.data;
  },

  /** Update mode issues no new token, so this only confirms recovery. */
  async completeReconnect(dataSourceId: string): Promise<{ success: boolean }> {
    const response = await api.post(
      `/api/integrations/plaid/data-sources/${dataSourceId}/reconnect-complete`,
    );
    return response.data;
  },
};
